import React from 'react';
import ShortcutPage from '../components/ShortcutPage';

interface ContainerProps {
  isFullScreen: boolean;
}
const OthersTab: React.FC<ContainerProps> = ({isFullScreen}) => {
  return (
    <ShortcutPage KEY="OTHERS" isFullScreen={isFullScreen} />
  )

};

export default OthersTab;
